<div class="main-container" data-cy="file-manager-upload-container">

  @if (showError) {
    <div class="error-message" data-cy="file-manager-upload-error">
      {{ error }}
    </div>
  }

  <div class="upload-box" data-cy="file-manager-upload-box">
    <div class="drop-container"
      ngFileDrop
      (uploadOutput)="onUploadOutput($event)"
      [uploadInput]="uploadInput"
      [options]="options"
      data-cy="file-manager-upload-drop-zone">
      <p class="drop-text" data-cy="file-manager-upload-instructions">

        Drag files here or
        <label class="upload-button" data-cy="file-manager-upload-button-label">
          <input type="file"
            class="file-input"
            ngFileSelect
            (uploadOutput)="onUploadOutput($event)"
            [uploadInput]="uploadInput"
            [options]="options"
            multiple
            data-cy="file-manager-upload-file-input">
            click here to browse
          </label>
          and upload
        </p>
      </div>
    </div>

    <div class="upload-item-container" data-cy="file-manager-upload-items">

      @for (file of files; track file; let i = $index) {
        <div class="upload-item" data-cy="file-manager-upload-item-{{i}}">
          <div class="filename" data-cy="file-manager-upload-filename-{{i}}">
            <span data-cy="file-manager-upload-name-{{i}}">{{ file.name }}</span>
          </div>
          <div class="progress-content" data-cy="file-manager-upload-progress-content-{{i}}">
            <div class="progress-bar-container" data-cy="file-manager-upload-progress-bar-container-{{i}}">
              @if (file.progress?.data?.percentage !== 100) {
                <mat-progress-bar mode="determinate"
                  [value]="file?.progress?.data?.percentage"
                data-cy="file-manager-upload-progress-bar-uploading-{{i}}"></mat-progress-bar>
              }
              @if (file.progress?.data?.percentage === 100 && fileStatus[i] && fileStatus[i].processing && !fileStatus[i].error) {
                <mat-progress-bar mode="indeterminate"
                data-cy="file-manager-upload-progress-bar-processing-{{i}}"></mat-progress-bar>
              }
              @if (file.progress?.data?.percentage === 100 && fileStatus[i] && !fileStatus[i].processing) {
                <mat-progress-bar mode="determinate"
                  [value]="file?.progress?.data?.percentage"
                data-cy="file-manager-upload-progress-bar-complete-{{i}}"></mat-progress-bar>
              }
            </div>
            <div class="progress-text-content" data-cy="file-manager-upload-progress-text-content-{{i}}">
              <span class="progress-text" [class.is-done]="file?.progress?.data?.percentage === 100" data-cy="file-manager-upload-progress-text-{{i}}">
                @if (file.progress?.data?.percentage !== 100) {
                  <span class="percentage" data-cy="file-manager-upload-percentage-uploading-{{i}}">{{ file.progress?.data?.percentage }}% </span>
                }
                @if (file.progress?.data?.percentage === 100 && fileStatus[i] && fileStatus[i].processing) {
                  <span class="percentage" data-cy="file-manager-upload-percentage-processing-{{i}}">99%</span>
                }
                @if (file.progress?.data?.percentage === 100 && fileStatus[i] && !fileStatus[i].processing) {
                  <span class="percentage" data-cy="file-manager-upload-percentage-complete-{{i}}">{{ file.progress?.data?.percentage }}%</span>
                }
                @if (file.progress?.data?.percentage !== 100 && fileStatus[i]?.processing) {
                  <span class="file-processing" data-cy="file-manager-upload-status-uploading-{{i}}">Uploading...</span>
                }
                @if (file.progress?.data?.percentage === 100 && fileStatus[i] && fileStatus[i].processing) {
                  <span class="file-processing" data-cy="file-manager-upload-status-processing-{{i}}">Processing</span>
                }
                @if (file.progress?.data?.percentage === 100 && fileStatus[i] && !fileStatus[i].processing && !fileStatus[i].error) {
                  <span class="file-done" data-cy="file-manager-upload-status-done-{{i}}">Done</span>
                }
                @if (fileStatus[i] && fileStatus[i].error) {
                  <span class="file-error" data-cy="file-manager-upload-status-error-{{i}}">{{ fileStatus[i].error }}</span>
                }
              </span>
              @if (file.progress?.data?.percentage !== 0 && file.progress?.data?.percentage !== 100) {
                <span class="speed-and-eta-text" data-cy="file-manager-upload-speed-eta-{{i}}">
                  <span data-cy="file-manager-upload-speed-{{i}}">{{ file.progress?.data?.speedHuman }} </span>
                  <span data-cy="file-manager-upload-eta-{{i}}">ETA {{ file.progress?.data?.etaHuman }}</span>
                </span>
              }
            </div>
          </div>
          <mat-divider class="item-divider" data-cy="file-manager-upload-divider-{{i}}"></mat-divider>
        </div>
      }

    </div>

    <div class="action-container" data-cy="file-manager-upload-actions">
      <button mat-raised-button color="primary" class="camera-button" (click)="openCameraModule()" data-cy="file-manager-upload-camera-button"><i class="material-icons">camera_alt</i></button>
      <button mat-raised-button color="primary" (click)="closeRef()" data-cy="file-manager-upload-ok-button">Ok</button>
    </div>

  </div>
